var map = {
	"./Dashboard": 97,
	"./Dashboard.js": 97,
	"./Wholesaler": 109,
	"./Wholesaler.js": 109,
	"./dialog/PriceFeeDialog": 108,
	"./dialog/PriceFeeDialog.js": 108,
	"./dialog/WholesalerDialog": 86,
	"./dialog/WholesalerDialog.js": 86,
	"./resources/address.png": 128,
	"./resources/coins.png": 118,
	"./resources/phone.png": 143,
	"./resources/store.png": 353,
	"./resources/wheeler.png": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;